import React from "react"
import ChooseFirstLocationModal from "../Screens/ChooseFirstLocationModal"

type Props = Readonly<{
    userHasNoLocation: boolean
    open: boolean
    onClose: () => void
}>

export function ChooseFirstLocationAdapter({ userHasNoLocation, open, onClose}: Props) {
    return (
        <>
            {open && (
                <ChooseFirstLocationModal
                    open={open}
                    onClose={onClose}
                    userHasNoLocation={userHasNoLocation}
                />
            )}
        </>
    )
}
